import { Post } from "../utils/http.js"

// 获取地址列表
export function getGoogleMapAddress(params) {
  return Post("/api/googleMap/near", params)
}
export function addAddress(params) {
  return Post("/api/order/consign/create", params, {
    loading: true
  })
}
export function modifyAddress(params) {
  return Post("/api/order/consign/modify", params, {
    loading: true
  })
}
export function deleteAddress(params) {
  return Post("/api/order/consign/del", params, {
    loading: true
  })
}

export function checkAddressValidForAnyStore(params) {
  return Post("/api/order/address/checkAddressValidForAnyStore", params, {
    loading: true
  })
}

// 获取选择地址的具体信息
export function getLocationByPlaceId(params) {
  return Post("/api/googleMap/getLocationByPlaceId", params, {
    loading: true
  })
}
